
import { defineComponent } from '@nuxtjs/composition-api'
import { fieldHelpPosition, fieldLabelPosition, fieldName, fieldValidationArray, fieldVisible } from '~/assets/formie'

export default defineComponent({
  props: {
    settings: { type: Object, required: true },
    parentField: { type: Object, required: false, default: undefined },
    field: { type: Object, required: true },
  },
  setup(props) {
    return {
      helpPosition: fieldHelpPosition(props.settings, props.field),
      labelPosition: fieldLabelPosition(props.settings, props.field),
      name: fieldName(props.field, props.parentField),
      show: fieldVisible(props.field),
      validation: [
        ...fieldValidationArray(props.field),
        ['number'],
        typeof props.field.minValue === 'number' && typeof props.field.maxValue === 'number' ? ['between', props.field.minValue, props.field.maxValue] : undefined,
        typeof props.field.minValue === 'number' && typeof props.field.maxValue !== 'number' ? ['min', props.field.minValue] : undefined,
        typeof props.field.minValue !== 'number' && typeof props.field.maxValue === 'number' ? ['max', props.field.maxValue] : undefined,
      ].filter((rule) => rule),
    }
  },
})
